import { consentPartnerMap, onetrustConsentPartnerMap } from "../consent/partner";
import { exactagScope } from "./utils";

const log = exactagScope.scope("core.data");

/**
 *
 */
export const baseParams = [
  "campaign",
  "pt",
  "uu",
  "ls",
  "hc",
  "cs",
  "ag",
  "pz",
  "ka",
  "bp",
  "sf",
  "cb",
  "xo",
  ...Object.values({ ...consentPartnerMap, ...onetrustConsentPartnerMap }),
] as const;

/**
 *
 */
export type BaseParams = (typeof baseParams)[number];

/**
 *
 */
export type ExactagValue = number | string | undefined | ExactagData;

/**
 *
 */
export type ExactagData = { [P in BaseParams]?: ExactagValue } & { [label: string]: ExactagValue };

/**
 *
 */
export const exactagData: ExactagData = {};

/**
 *
 *
 *
 *
 *
 */
export function removeEmptyItems(data: ExactagData = exactagData, visited = new Set()): ExactagData {
  /*                                                       */
  if(visited.has(data)) return data;
  visited.add(data);

  /*                                   */
  (Object.keys(data) as (keyof ExactagData)[]).forEach((key) => {
    if (data[key] === "") {
      delete data[key];
    } else if (data[key] && typeof data[key] === "object") {
      /*                                                                               */
      removeEmptyItems(data[key] as never, visited);
    }
  });

  return data;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function cacheUserData(data = exactagData): ExactagData {
  (Object.keys(data) as BaseParams[]).forEach((key) => {
    if (!baseParams.includes(key)) delete data[key];
  });

  log.debug("Cached user data", data);
  return data;
}

export function getExactagData(): ExactagData {
  return { ...exactagData };
}

export function updateExactagData(newData: ExactagData): ExactagData {
  Object.assign(exactagData, newData);
  return exactagData;
}
